import type { Control, UseFormSetValue } from 'react-hook-form';
import type { z } from 'zod';

import type { step3Schema } from './validation';

export enum Step {
  GeneralEntityData = 1,
  BaseEntityData = 2,
  BrandingInfo = 3,
}

export type CreateEntityFormState = z.infer<typeof step3Schema>;

export interface StepProps {
  control: Control<CreateEntityFormState>;
  formValues: CreateEntityFormState;
  setValue: UseFormSetValue<CreateEntityFormState>;
}

export type EntityModalType = 'template' | 'contract';
